<template>
  <div>
    <!-- banner區 開始 -->
    <div class="banner">
      <!-- 手機版 -->
      <Carousel radius-dot autoplay :autoplay-speed="5000" :trigger="'click'" :arrow="'always'" loop class="bannerpic">
        <CarouselItem v-for="(item, index) in bannerListMb" :key="index">
          <div class="item">
            <img class="big" :src="item" alt="banner">
          </div>
        </CarouselItem>
      </Carousel>
      <!-- 電腦版 -->
      <Carousel radius-dot autoplay :autoplay-speed="5000" :trigger="'click'" :arrow="'always'" loop class="biggerpic">
        <CarouselItem v-for="(item, index) in bannerList" :key="index">
          <div class="item">
            <img class="big" :src="item" alt="banner">
          </div>
        </CarouselItem>
      </Carousel>
      <div class="scrdown">
        <a href="#about-id">
        <p>scroll<br>down</p>
        <img :src="downTriangle" alt="">
        </a>
      </div>
    </div>
    <!-- banner區 結束 -->
    <!-- ABOUT區 開始 -->
    <div class="about" id="about-id">
      <div class="about_pic">
        <div class="pic">
          <router-link to="/About"><h2>ABOUT</h2></router-link>
          <p class="lightp_color_bg"></p>
          <img :src="handwrite" alt="">
        </div>
        <router-link to="/About">
        <img class="about_bigpic" :src="aboutImg" alt=""></router-link>
        <span class="darkp_color_bg"></span>
        <h3></h3>
        <div class="emma_handwrit">
          <img :src="handwrite" alt="">
        </div>
      </div>
      <div class="about_text">
        <p class="animate__animated animate__slideInUp animate__slow">
          Taiwan based, Ethical jeweler Emma Lee has been making jewelery for
            over 25 years.  Emma Lee went on to work all over the world with artisans creating unique handmade jewelery in warm yellow gold.
        </p>
        <div class="more">
          <router-link to="/About">MORE</router-link>
        </div>
      </div>
      <h6>Our pieces are design to love</h6>
    </div>
    <!-- ABOUT區 結束 -->
    <!-- COLLECTION區 開始 -->
    <div class="coll_bg">
      <div class="coll_title">
        <h2>COLLECTIONS</h2>
      </div>
      <div class="wrapA">
        <div class="collA_outer">
          <div class="collA_big">
            <router-link to="/Pacific">
              <img :src="collectionImg01" class="collAbig" alt="">
            </router-link>
            <div class="collA_small_pic">
              <router-link to="/Pacific">
                <img :src="collAsmall" class="collAsmall" alt="">
              </router-link>
            </div>
          </div>
          <div class="collAtext">
            <a href="#"><h3>LUNA BLUES</h3></a>
            <p>Waves of mixed blue gems and gold</p>
            <div class="more">
              <a href="#">MORE</a>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapB">
        <div class="collB_outer">
          <div class="collB_big ">
            <a href="#">
              <img :src="collectionImg02" alt="" class="collBbig">
            </a>
            <div class="collB_small_pic">
              <a href="#">
                <img :src="collBsmall" class="collBsmall" alt="">
              </a>
            </div>
          </div>
          <div class="collB_small">
            <div class="collBtext">
              <a href="#"><h3>CRYSTAL</h3></a>
              <p>White gems and gold</p>
              <div class="more">
                <a href="#">MORE</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- COLLECTION區 結束 -->
    <!-- WHAT'S HOT區 開始 -->
    <div class="whathot">
      <div class="what_wrap">
        <div class="whatContainer col-12 col-md-7">
          <!-- Title區 開始 -->
          <div class="whatTitle">
            <router-link to="/Pacific">
              <h2>WHAT'S HOT</h2>
            </router-link>
            <a href="#">
              <p>PACIFIC</p>
            </a>
            <!-- 點點背景圖 開始 -->
            <div class="imgs">
              <!-- 手機版點點背景 -->
              <div class="mobile">
                <img :src="whathotBgMb" alt="">
                <img class="darkblue" :src="whathotBgMbDark" alt="">
                <img class="green" :src="whathotBgMbGreen" alt="">
                <img class="lightblue" :src="whathotBgMbLight" alt="">
              </div>
              <!-- PC版點點背景 -->
              <div class="pcimg">
                <img :src="whathotBg" alt="">
                <img class="darkblue" :src="whathotBgDark" alt="">
                <img class="green" :src="whathotBgGreen" alt="">
                <img class="lightblue" :src="whathotBgLight" alt="">
              </div>
            </div>
            <!-- 點點背景圖 結束 -->
          </div>
          <!-- Title區 結束 -->
          <!-- 商品pc輪播圖 開始 -->
          <div class="thumb-wrap">
            <!-- swiper1 -->
            <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
              <swiper-slide class="slide-1">
                <img :src="whathotb01" alt="">
              </swiper-slide>
              <swiper-slide class="slide-2">
                <img :src="whathotb02" alt="">
              </swiper-slide>
              <swiper-slide class="slide-3">
                <img :src="whathotb03" alt="">
              </swiper-slide>
              <swiper-slide class="slide-4">
                <img :src="whathotb04" alt="">
              </swiper-slide>
              <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
              <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            </swiper>
            <!-- swiper2 Thumbs -->
            <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
              <swiper-slide class="slide-1">
                <img :src="whathots01" alt="">
              </swiper-slide>
              <swiper-slide class="slide-2">
                <img :src="whathots02" alt="">
              </swiper-slide>
              <swiper-slide class="slide-3">
                <img :src="whathots03" alt="">
              </swiper-slide>
              <swiper-slide class="slide-4">
                <img :src="whathots04" alt="">
              </swiper-slide>
            </swiper>
          </div>
          <!-- 商品pc輪播圖 結束 -->
        </div>
        <!-- 商品翻轉輪播圖 開始 -->
        <div class="bigPro col-12 col-md-5">
          <div class="bigpro_wrap slider slider-for">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide>
                <img :src="whathotb01" alt="">
              </swiper-slide>
              <swiper-slide>
                <img :src="whathotb02" alt="">
              </swiper-slide>
              <swiper-slide>
                <img :src="whathotb03" alt="">
              </swiper-slide>
              <swiper-slide>
                <img :src="whathotb04" alt="">
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
        <!-- 商品翻轉輪播圖 結束 -->
      </div>
    </div>
    <!-- WHAT'S HOT區 結束 -->
    <!-- JEWELRY區 開始 -->
    <div class="category">
      <div class="cagTitle">
        <h2>JEWELRY</h2><span></span>
      </div>
      <!-- 耳環 -->
      <div class="EARRINGS_wrap">
        <div
          class="EARRING_img"
          data-aos="fade-left"
          data-aos-offset="500"
          data-aos-easing="ease-in-sine"
        >
          <router-link to="/Earrings">
            <img :src="jewelryEarring" alt="">
          </router-link>
        </div>
        <div class="EARRING_text">
          <router-link to="/Earrings">
            <p data-aos="fade-right">TAKE A LOOK AT<br>OUR EARRINGS</p>
          </router-link>
        </div>
      </div>
      <!-- 戒指 -->
      <div class="RING_wrap">
        <div
          class="RING_img"
          data-aos="fade-right"
          data-aos-offset="500"
          data-aos-easing="ease-in-sine"
        >
          <a href="#">
            <img :src="jewelryRing" alt="">
          </a>
        </div>
        <div class="RING_text">
          <a href="#">
            <p data-aos="fade-left">SHOP OUR RINGS <br> AND EVERYDAY STYLE</p>
          </a>
        </div>
      </div>
      <!-- 項鍊 -->
      <div class="NACKLACE_wrap">
        <div
          class="NACKLACE_img"
          data-aos="fade-left"
          data-aos-offset="500"
          data-aos-easing="ease-in-sine"
        >
          <a href="#">
            <img :src="jewelryNecklace" alt="">
          </a>
        </div>
        <div class="NACKLACE_text">
          <a href="#">
            <p data-aos="fade-right">SEE HOW WE CAN HELP YOU <br>FIND YOUR OWN NACKLACES</p>
          </a>
        </div>
      </div>
      <!-- 手環 -->
      <div class="BRACELET_wrap">
        <div
          class="BRACELET_img"
          data-aos="fade-right"
          data-aos-offset="500"
          data-aos-easing="ease-in-sine"
        >
          <a href="#">
            <img :src="jewelryBracelet" alt="">
          </a>
        </div>
        <div class="BRACELET_text">
          <a href="#">
            <p data-aos="fade-left">TAKE A PEEK AT<br> OUR BRACELETS</p>
          </a>
        </div>
      </div>
    </div>
    <!-- JEWELRY區 結束 -->
    <!-- MAKE IT BESPOKE 開始-->
    <div class="bespoke">
      <div class="be_title">
        <router-link to="/Bespoke">
          <h2>MAKE IT BESPOKE</h2>
        </router-link >
      </div>
      <div class="be_container">
        <div class="bepic col-12 col-md-6">
          <router-link to="/Bespoke">
            <img :src="bespokeImg" alt="">
          </router-link>
        </div>
        <div class="bespText col-12 col-md-6">
          <div>
            <img class="L" :src="bespokeLeftIcon" alt="">
          </div>
          <p>We offers a range of bspoke services. from engagement rings and friendship bracelets to corporate gifting.</p>
          <div>
          </div>
          <img class="R" :src="bespokeRightIcon" alt="">
        </div>
        <div class="more">
          <router-link to="/Bespoke">MORE</router-link>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <!-- MAKE IT BESPOKE 結束-->
    <!-- STORE 開始-->
    <div class="store">
      <div class="storeText">
        <router-link to="/Store">
          <h2>STORE</h2>
        </router-link>
        <router-link to="/Store">
          <p>
            New York City<br>
            Corporate Headquarters 25 West<br> 26th St.,5th Floor<br>
          </p>
        </router-link>
        <h6>Tel：＋81(0)3-5726-9810</h6>
        <a href="#">
          <h5>Email: shop@emmalee.com</h5>
        </a>
      </div>
    </div>
    <!-- STORE 結束-->
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// banner
import bannerMb01 from '@/assets/mobile/home/bannerbg_mobile.jpg'
import bannerMb02 from '@/assets/mobile/home/bg-3_mobile_word.jpg'
import bannerMb03 from '@/assets/mobile/home/bg-2_mobile_word.jpg'
import banner01 from '@/assets/pc/home/bannerbg_word.jpg'
import banner02 from '@/assets/pc/home/bg-3_word.jpg'
import banner03 from '@/assets/pc/home/bg-2_word.jpg'
import downTriangle from '@/assets/pc/home/down_tri.png'
// about
import handwrite from '@/assets/pc/home/Emmalee_handwrite.png'
import aboutImg from '@/assets/pc/home/about_img.jpg'
// collection
import collectionImg01 from '@/assets/pc/home/collection_img01.jpg'
import collAsmall from '@/assets/pc/home/collA_s.png'
import collectionImg02 from '@/assets/pc/home/collection_img02.jpg'
import collBsmall from '@/assets/pc/home/collB_s.png'
// whathot
import whathotBgMb from '@/assets/pc/home/whathot_bg_mobile.png'
import whathotBgMbDark from '@/assets/pc/home/whathot_bg_mobile_darkblue.png'
import whathotBgMbGreen from '@/assets/pc/home/whathot_bg_mobile_green.png'
import whathotBgMbLight from '@/assets/pc/home/whathot_bg_mobile_lightblue.png'
import whathotBg from '@/assets/pc/home/whathot_bg.png'
import whathotBgDark from '@/assets/pc/home/whathot_bg_dots_darkblue.png'
import whathotBgGreen from '@/assets/pc/home/whathot_bg_dots_green.png'
import whathotBgLight from '@/assets/pc/home/whathot_bg_dots_lightblue.png'
import whathots01 from '@/assets/pc/home/whathot_s01.png'
import whathots02 from '@/assets/pc/home/whathot_s02.png'
import whathots03 from '@/assets/pc/home/whathot_s03.png'
import whathots04 from '@/assets/pc/home/whathot_s04.png'
import whathotb01 from '@/assets/pc/home/whathot_big01_words.jpg'
import whathotb02 from '@/assets/pc/home/whathot_big02_words.jpg'
import whathotb03 from '@/assets/pc/home/whathot_big03_words.jpg'
import whathotb04 from '@/assets/pc/home/whathot_big04_words.jpg'
// jewelry
import jewelryEarring from '@/assets/pc/home/earring.png'
import jewelryRing from '@/assets/pc/home/ring.png'
import jewelryNecklace from '@/assets/pc/home/necklace.png'
import jewelryBracelet from '@/assets/pc/home/bracelet.png'
// bespoke
import bespokeImg from '@/assets/pc/home/bespoke_img.png'
import bespokeLeftIcon from '@/assets/pc/home/leftIcon.png'
import bespokeRightIcon from '@/assets/pc/home/rightIcon.png'

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  mounted () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  data () {
    return {
      bannerListMb: [
        bannerMb01,
        bannerMb02,
        bannerMb03
      ],
      bannerList: [
        banner01,
        banner02,
        banner03
      ],
      downTriangle,
      handwrite,
      aboutImg,
      collectionImg01,
      collectionImg02,
      collAsmall,
      collBsmall,
      whathotBgMb,
      whathotBgMbDark,
      whathotBgMbGreen,
      whathotBgMbLight,
      whathotBg,
      whathotBgDark,
      whathotBgGreen,
      whathotBgLight,
      whathots01,
      whathots02,
      whathots03,
      whathots04,
      whathotb01,
      whathotb02,
      whathotb03,
      whathotb04,
      jewelryEarring,
      jewelryRing,
      jewelryNecklace,
      jewelryBracelet,
      bespokeImg,
      bespokeRightIcon,
      bespokeLeftIcon,
      swiperOption: {
        effect: 'flip',
        grabCursor: true,
        speed: 1000,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionTop: {
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true
      }
    }
  },
  methods: {
  }
}
</script>

<style>
@import url(../../assets/scss/dev/grid.css);
.fade-enter-active,
.fade-leave-active {
  transition: all .8s ease-in;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}
/* 手機 */
.category {
  width: 100%;
  max-width: 1280px;
  margin: auto;
  background-image: url(../../assets/pc/home/category_bg_mobile.jpg);
  background-attachment: fixed;
}
.store{
  width: 100%;
  max-width: 1280px;
  background: url(../../assets/pc/home/store_bg_mobile.jpg) no-repeat;
  background-size: cover;
  margin-top: -5vw;
  margin-right: auto;
  margin-left: auto;
  padding-top: 20vw;
  padding-bottom: 20vw;
}
/* PC */
@media screen and (min-width: 768px) {
  .pic a:first-child {
    display: block;
    background-image: url(../../assets/pc/home/about_img.jpg);
    width: 700px;
    height: 505px;
    position: relative;
    left:130px;
    margin-top: 145px;
  }
  .category {
    width: 100%;
    max-width: 1280px;
    margin: auto;
    background-image: url(../../assets/pc/home/category_bg.jpg);
    background-size: cover;
    background-attachment: fixed;
    background-repeat: repeat;
  }
  /*store區*/
  .store {
    background: url(../../assets/pc/home/store_bg.jpg) no-repeat fixed;
    background-size: cover;
    margin-top: -15px;
    margin-right: auto;
    margin-left: auto;
    padding-top: 120px;
    padding-bottom: 130px;
  }
}
</style>
